function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M14.4.5H1.6C.72.5.008 1.231.008 2.125L0 11.875c0 .894.72 1.625 1.6 1.625h12.8c.88 0 1.6-.731 1.6-1.625v-9.75C16 1.231 15.28.5 14.4.5zm0 3.25L8 7.813 1.6 3.75V2.125L8 6.188l6.4-4.063V3.75z",
  id: "mail_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -.5)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "mail_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#mail_svg__a"
})), React.createElement("use", {
  fill: "#496E9B",
  fillRule: "nonzero",
  xlinkHref: "#mail_svg__a"
}), React.createElement("g", {
  mask: "url(#mail_svg__b)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M-2-3h20v20H-2z"
})));

var Mail = function Mail(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 13"
  }, props), _ref, _ref2);
};

export default Mail;